import { ActionTitle } from '../enums';
import ViewSoldPropertyAction from './view-sold-property.action';

export default class ViewSoldPropertyComparablesAction extends ViewSoldPropertyAction {
  title = ActionTitle.ViewSoldProperty;
}
